<template>
  <v-dialog
    ref="dialogContainer"
    content-class="dialog-container s-dialog"
    :persistent="persistent"
    v-model="openState">

    <div class="dialog-container2">
      <div v-if="title" class="dialog__title-container">
        <div class="dialog__title-content">
          <h1 class="dialog__title">{{ title }}</h1>
          <h3 class="dialog__subtitle" v-if="subtitle" v-html="subtitleHtml"></h3>
        </div>
        <v-btn
          v-if="hasCloseBtn"
          icon="close" variant="text"
          class="dialog__close-btn"
          @click="closeDialog">
        </v-btn>
      </div>
      <v-tabs
        v-if="tabs || tabs && tabs.length > 0"
        v-model="tabBar"
        bg-color="#f2f2f2"
        :centered="true"
        center-active
        grow>
        <v-tab
          v-for="tab in tabs"
          :key="tab">
          {{tab}}
        </v-tab>
      </v-tabs>
      <template v-if="contentComponent">
        <component :is="contentComponent" v-bind="props"/>
      </template>
    </div>

  </v-dialog>
</template>

<script>
import { loadShallowAsyncComponent } from '@/helpers/asyncLoaders'
import escapeHtml from 'escape-html'
import { mapState, mapActions } from 'vuex'

import {
  VUEX_DIALOG_HIDE,
  VUEX_DIALOG_SET_PROPS
} from '@/store/constants/ui/dialog'

export default {
  name: 'SDialog',

  data: () => ({
    contentComponent: null
  }),

  computed: {
    ...mapState({
      content: state => state.amDialog.content,
      title: state => state.amDialog.title,
      subtitle: state => state.amDialog.subtitle,
      tabs: state => state.amDialog.tabs,
      props: state => state.amDialog.props
    }),

    openState: {
      get () { return this.$store.state.amDialog.openState },
      set () { this.closeDialog() }
    },

    tabBar: {
      get () { return this.$store.state.amDialog.tabBar },
      set (val) { this.setDialogProps({ tabBar: val }) }
    },

    subtitleHtml () {
      if (this.props?.subtitleRawHtml) {
        return this.subtitle
      } else {
        return escapeHtml(this.subtitle)
      }
    },

    persistent () {
      return /* this.props?.persistent || */ true
    },

    hasCloseBtn () {
      const closeBtn = this.props?.closeBtn
      return typeof closeBtn === 'boolean' ? closeBtn : true
    }
  },

  created () {
    this.loadContent()
  },

  methods: {
    ...mapActions({
      closeDialog: VUEX_DIALOG_HIDE,
      setDialogProps: VUEX_DIALOG_SET_PROPS
    }),

    loadContent () {
      this.contentComponent = this.content
        ? loadShallowAsyncComponent(this.content)
        : null
    }
  },

  watch: {
    content: {
      handler () {
        this.loadContent()
      }
    }
  }
}
</script>

<style lang="scss">
  .v-dialog .dialog-container {
    min-height: 4rem;
    background-color: white;
    width: auto;
  }

  .v-dialog .dialog-container2 {
    overflow-y: auto;
    min-height: 4rem;
    background-color: white;
    width: auto;

    .dialog__title-container {
      position: relative;
      background-color: $app-color-grey--light-4;
      text-align: center;
      height: 9rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .dialog__title-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .dialog__title {
        font-weight: 400;
        max-width: 550px;
      }

      .dialog__subtitle {
        font-weight: 400;
        font-size: 0.88rem;
        max-width: 500px;
        word-break: break-word;
      }

    }

    .dialog__close-btn {
      position: absolute;
      right: 0.5rem;
      top: 0.5rem;
    }

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
      background: $app-color-grey--light-4;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: $app-color-black-alpha-25;
    }
  }
</style>
